// test610
(610 && 0);
